// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18wMX","importantInfo":"styles_importantInfo__1aUcP"};